import { useId } from "react";
import { motion } from "framer-motion";
import { motionAllowed } from "./motionEnv";

/**
 * A jar outline that fills with golden oil to `level` (0 to 1), with a
 * gentle wave on top. Pure SVG, no canvas or WebGL, so it is cheap on phones.
 */
const JAR = "M28 78 h164 a22 22 0 0 1 22 22 v124 a26 26 0 0 1 -26 26 h-156 a26 26 0 0 1 -26 -26 v-124 a22 22 0 0 1 22 -22 z";

export default function OilFill({ level = 0.5, label = "", className = "" }) {
  const id = useId().replace(/:/g, "");
  // Oil rises from the base (y 250) to just under the neck (y 92).
  const top = 250 - 158 * Math.min(1, Math.max(0.04, level));
  const animate = motionAllowed();
  const wave = (y) => `M0 ${y} Q 30 ${y - 8} 60 ${y} T 120 ${y} T 180 ${y} T 240 ${y} V 260 H 0 Z`;
  return (
    <svg viewBox="0 0 220 260" className={className} role="img" aria-label={label}>
      <defs>
        <clipPath id={`b-${id}`}><path d={JAR} /></clipPath>
        <linearGradient id={`o-${id}`} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#F3E3A1" />
          <stop offset="1" stopColor="#D9B75A" />
        </linearGradient>
      </defs>
      <g clipPath={`url(#b-${id})`}>
        <rect x="0" y="0" width="220" height="260" fill="rgba(255,255,255,0.06)" />
        {animate ? (
          <motion.path
            fill={`url(#o-${id})`}
            initial={{ d: wave(250) }}
            animate={{ d: [wave(top), wave(top + 4), wave(top)] }}
            transition={{ d: { duration: 2.6, repeat: Infinity, ease: "easeInOut" } }}
          />
        ) : (
          <path fill={`url(#o-${id})`} d={wave(top)} />
        )}
      </g>
      <path d={JAR} fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.5" />
      <rect x="30" y="62" width="160" height="18" rx="5" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" />
      <rect x="24" y="18" width="172" height="46" rx="9" fill="#0B0B0A" stroke="rgba(255,255,255,0.4)" />
    </svg>
  );
}
